// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"feedteststyle_headerColumn__6DXZ7kOrf6ZbOpfRhIOg5","rowColumn":"feedteststyle_rowColumn__19uDH3Ln61euwgH6aMjTwJ"};